import { useToast } from '../../context/ToastContext';
import Icon from './Icon';
import './Toast.css';

const Toast = () => {
  const { toasts, hideToast } = useToast();

  if (toasts.length === 0) return null;

  const getIcon = (type) => {
    switch (type) {
      case 'success': return 'check-circle';
      case 'error': return 'x-circle';
      case 'warning': return 'alert-triangle';
      default: return 'info';
    }
  };

  return (
    <div className="toast-container" role="alert" aria-live="polite">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`toast toast-${toast.type}`}
        >
          <Icon name={getIcon(toast.type)} size="md" />
          <span className="toast-message">{toast.message}</span>
          <button
            className="toast-close"
            onClick={() => hideToast(toast.id)}
            aria-label="Close notification"
          >
            <Icon name="x" size="sm" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default Toast;
